module.exports = window.__LR__.dependencies.load(window.__LR_GLOBAL_APP_NAME__);